module.exports = __webpack_public_path__ + "img/skin_v5bo4q_c_scale,w_928.95da0e2f.jpg";